// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1e0c11p5{display:grid}\n._4cvr1h6o{align-items:center}\n._4t3i1pna{height:420px}", ""]);
// Exports
module.exports = exports;
